module.exports = __webpack_public_path__ + "static/media/getHoney.b661df5a.svg";